import { combineReducers } from 'redux'
import * as AT from '../actions/_types'
import { hasProducts } from '../constants'

export default combineReducers({
  user,
  auth,
})

function user(
  prevState = {
    activeLocation: null,
    callerIdEnabled: false,
    countryCode: '',
    isPracticeAdmin: false,
    locations: [],
    phoneNumbers: [],
    practiceName: null,
    timezone: '',
    username: '',
  },
  action,
) {
  switch (action.type) {
    case AT.ACCT_CURR_USER: {
      const {
        activeLocation,
        caller_id_enabled,
        isPracticeAdmin,
        locations,
        phoneNumbers,
        practiceName,
        timezone,
        username,
      } = action

      return {
        activeLocation,
        callerIdEnabled: caller_id_enabled,
        countryCode: action.country_code,
        isPracticeAdmin,
        phoneNumbers,
        practiceName,
        locations,
        timezone,
        username,
      }
    }
    case AT.ACCT_TOGGLE_CALLER_ID: {
      const newState = { ...prevState }
      newState.callerIdEnabled = !prevState.callerIdEnabled
      return newState
    }
    case AT.ACCT_SET_ACTIVE_LOC: {
      const { activeLocation } = action
      return { ...prevState, activeLocation }
    }
    default: {
      return prevState
    }
  }
}

function auth(
  prevState = {
    hasDSO: false,
    hasPlum: false,
    hasMarketing: false,
    hasNewPatientOS: false,
    hasPatientPortal: false,
    hasReminders: false,
    hasRemindersTier2: false,
    hasReviews: false,
    hasScreenPop: false,
    hasTextingOnly: false,
    hasTopsAlertsPlus: false,
    hasTopsRemindersPlus: false,
    hasUnknownTexting: false,
    isFetching: false,
    isTokenPresent: false,
    pmsVersion: null,
    prevUrl: null,
    remainingBlastMessages: 0,
    tier: null,
  },
  action,
) {
  switch (action.type) {
    case AT.ACCT_LOGIN_SUCC: {
      return {
        ...prevState,
        isTokenPresent: true,
      }
    }
    case AT.ACCT_AUTHORIZATIONS: {
      const {
        hasPlum,
        hasUnknownTexting,
        products,
        remainingBlastMessages,
        remainingMmsMessages,
        tier,
        pmsType,
        pmsVersion,
        useCorrespondenceValues,
      } = action
      const productSet = new Set(products)
      const {
        hasDSO,
        hasMarketing,
        hasNewPatientOS,
        hasPatientPortal,
        hasReminders,
        hasRemindersTier2,
        hasReviews,
        hasScreenPop,
        hasTextingOnly,
        hasTopsAlertsPlus,
        hasTopsRemindersPlus,
      } = hasProducts(productSet)

      return {
        ...prevState,
        hasDSO,
        hasPlum,
        hasMarketing,
        hasNewPatientOS,
        hasPatientPortal,
        hasReminders,
        hasRemindersTier2,
        hasReviews,
        hasScreenPop,
        hasTextingOnly,
        hasTopsAlertsPlus,
        hasTopsRemindersPlus,
        hasUnknownTexting,
        remainingBlastMessages,
        remainingMmsMessages,
        tier,
        pmsType,
        pmsVersion,
        useCorrespondenceValues,
      }
    }
    case AT.ACCT_FETCHING: {
      return {
        ...prevState,
        isFetching: true,
      }
    }
    case AT.ACCT_FETCHED: {
      return {
        ...prevState,
        isFetching: false,
      }
    }
    case AT.ACCT_PREV_URL: {
      return {
        ...prevState,
        prevUrl: action.previous,
      }
    }
    case AT.ACCT_UPDATE_REMAINING_BLAST_MESSAGES: {
      return {
        ...prevState,
        remainingBlastMessages: action.remainingBlastMessages,
      }
    }
    case AT.ACCT_UPDATE_REMAINING_MMS_MESSAGES: {
      return {
        ...prevState,
        remainingMmsMessages: action.remainingMmsMessages,
      }
    }
    default: {
      return prevState
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/account.js